import React from 'react';
import classNames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';

import { useStyles } from './styles';

const CircularLoader = ({ isLoading, className, loaderClassName }) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classNames(classes.loaderWrapper, className)}>
        <CircularProgress
          disableShrink
          classes={{ root: classNames(classes.loaderItem, loaderClassName) }}
        />
      </div>
    );
  }

  return null;
};

export default CircularLoader;
